export default "__VITE_PUBLIC_ASSET__b32d8a6b__"